import React, { Component } from 'react';
import APP_DEFAULTS from '../../../constants/app-defaults';

import SUPPORTED_LOCALES, { LOCALE_FLAGS } from '../../../constants/supported-locales';

// Styles
import styles from '../styles/header.scss';

class LocaleSelector extends Component {
    constructor(props) {
        super(props);
        this.container = React.createRef();
        this.state = {
            showLanguageList: false,
        };

        this.toggleLanguageList = this.toggleLanguageList.bind(this);
    }

    setLanguage(localeKey) {
        this.props.setLocale(localeKey);
        this.toggleLanguageList();
    }

    handleClickOutside = (event) => {
        if (
            this.container.current && !this.container.current.contains(event.target)
        ) {
            document.removeEventListener('mousedown', this.handleClickOutside);
            this.setState({
                showLanguageList: false,
            });
        }
    }

    toggleLanguageList() {
        this.setState((prevState) => ({ showLanguageList: !prevState.showLanguageList }), () => {
            if (this.state.showLanguageList) {
                document.addEventListener('mousedown', this.handleClickOutside);
            } else {
                document.removeEventListener('mousedown', this.handleClickOutside);
            }
        });
    }

    render() {
        const localeSelectorMarkup = Object.keys(SUPPORTED_LOCALES).map((localeKey, idx) => (
            <li key={localeKey} value={localeKey} className="active" onClick={() => this.setLanguage(localeKey)}>
                <img className="flag" alt={SUPPORTED_LOCALES[localeKey]} src={LOCALE_FLAGS[localeKey]} />
            </li>
        ));

        return (
            <ul className={`nav navbar-nav navbar-right nav-language ${styles.navbarRight} ${styles.navLanguage}`} ref={this.container}>
                <li id="languages" className={`dropdown ${styles.languages}`}>
                    <a className={`dropdown-toggle line-double ${styles.dropdown}`} data-toggle="dropdown" onClick={this.toggleLanguageList}>
                        <img className="flag" alt={SUPPORTED_LOCALES[this.props.currentLocale]} src={LOCALE_FLAGS[this.props.currentLocale]} />
                        <i
                            className={`pe-7s-angle-down pe-1x pe-va font-weight-bold ${styles.angleDown}`}
                            style={{ display: this.state.showLanguageList ? 'none' : 'inline-block' }}
                        />
                        <i className={`pe-7s-angle-up pe-1x pe-va font-weight-bold ${styles.angleUp}`} style={{ display: this.state.showLanguageList ? 'inline-block' : 'none' }} />
                    </a>
                    <ul className={`dropdown-menu languages ${styles.languageDropdowns}`} style={{ display: this.state.showLanguageList ? 'block' : 'none' }}>
                        {localeSelectorMarkup}
                    </ul>
                </li>
            </ul>
        );
    }
}

export default LocaleSelector;



/** WEBPACK FOOTER **
 ** ./src/components/shared/header/locale-selector.jsx
 **/